import { useSelector } from "@tanstack/react-store";
import type { FC } from "react";

import { m } from "@recobra/i18n/messages";

import { TaskAssigneePicker } from "../task-display";
import { TaskSummaryRow } from "../task-display";
import type { TaskCreationFormApi } from "./useTaskCreationForm";

/** Only rendered for creators who may assign; picking is the section's only job. */
export const TaskAssigneeSection: FC<{
  form: TaskCreationFormApi;
  isOpen: boolean;
  contextId: string;
  contextType: "case" | "client";
}> = ({ form, isOpen, contextId, contextType }) => {
  const taskType = useSelector(form.store, (state) => state.values.taskType);

  return (
    <form.AppField name="assignedTo">
      {(field) => (
        <TaskSummaryRow label={m.task_field_assignee()}>
          <TaskAssigneePicker
            taskType={taskType}
            contextId={contextId}
            contextType={contextType}
            value={field.state.value}
            enabled={isOpen}
            automaticWhenEmpty
            onChange={field.handleChange}
          />
        </TaskSummaryRow>
      )}
    </form.AppField>
  );
};
